/**
 * @generated SignedSource<<663b2aaff2b83d1e5a584b5fd70b51f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type urlParams_thirdPartyToggleDefaults$data = {
  readonly currentUser: {
    readonly customer: {
      readonly showThirdPartyErrors: boolean;
      readonly showThirdPartyWarnings: boolean;
    };
  };
  readonly " $fragmentType": "urlParams_thirdPartyToggleDefaults";
};
export type urlParams_thirdPartyToggleDefaults$key = {
  readonly " $data"?: urlParams_thirdPartyToggleDefaults$data;
  readonly " $fragmentSpreads": FragmentRefs<"urlParams_thirdPartyToggleDefaults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "urlParams_thirdPartyToggleDefaults",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Customer",
          "kind": "LinkedField",
          "name": "customer",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showThirdPartyWarnings",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showThirdPartyErrors",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5b7f0971eeaa96b87d039d401d609655";

export default node;
